export default function ExperienceMember(props) {
  let directory_education_count = (
    <li>
      <a href="#">
        <figure>
          <img src="/static/images/svg/ico-pencil.svg" alt="Pencil ico" />
        </figure>

        <small>{props.hit.directory_education_count}</small>

        <span className="list__label">WoodWorks Education Attended</span>
      </a>
    </li>
  );
  let directory_speaker_count = (
    <li>
      <a href="#">
        <figure>
          <img src="/static/images/svg/ico-mic.svg" alt="Mic ico" />
        </figure>

        <small>{props.hit.directory_speaker_count}</small>

        <span className="list__label">WoodWorks Event Speaker</span>
      </a>
    </li>
  );
  let directory_lightframe_count = (
    <li>
      <a href="#">
        <figure>
          <img src="/static/images/svg/ico-tbd.svg" alt="Mic ico" />
        </figure>

        <small>{props.hit.directory_lightframe_count}</small>

        <span className="list__label">Innovative Light-Frame Projects</span>
      </a>
    </li>
  );
  let directory_masstimber_count = (
    <li>
      <a href="#">
        <figure>
          <img src="/static/images/svg/ico-building2.svg" alt="Building" />
        </figure>

        <small>{props.hit.directory_masstimber_count}</small>

        <span className="list__label">Mass Timber Projects</span>
      </a>
    </li>
  );

  const buildExperienceMember = ()=> {
    let experience = '';
    console.log('sadfasdF', props);
    experience.concat('', directory_education_count);
    if (props.hit.directory_education_count > 0) {

    }
    return experience;
  }

  return (
    <ul className="list-projects">
    { props.hit.directory_education_count > 0 && directory_education_count }
    { props.hit.directory_speaker_count > 0 && directory_speaker_count }
    { props.hit.directory_lightframe_count > 0 && directory_lightframe_count }
    { props.hit.directory_masstimber_count > 0 && directory_masstimber_count }
    </ul>
  );

}
